(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-tag-filter-search"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-blog-filter]').forEach(function(root) {

  var cards = Array.prototype.slice.call(
    root.querySelectorAll('[data-blog-card]')
  );

  var tabs = Array.prototype.slice.call(
    root.querySelectorAll('[data-blog-tabs] button')
  );

  var search = root.querySelector('[data-blog-search]');
  var empty = root.querySelector('[data-blog-no-results]');

  var template =
    root.dataset.noResultsText ||
    'No blogs related to your search were found in {{ tab }}.';

  var urlParams = new URLSearchParams(window.location.search);

  var activeTag = urlParams.get('category') || 'all';

  var activeLabel = 'Show all';


  function setActiveTab(tag) {

    tabs.forEach(function(tab) {

      tab.classList.remove('is-active');
      tab.setAttribute('aria-selected', 'false');

      if (tab.dataset.tag === tag) {

        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        activeLabel = tab.textContent.trim();

      }

    });

  }


  function applyFilter() {

    var query = search
      ? search.value.trim().toLowerCase()
      : '';

    var visibleCards = [];

    cards.forEach(function(card) {

      var tags = (card.dataset.tags || '')
        .split('|')
        .filter(Boolean);

      var title = card.dataset.title || '';
      var content = card.dataset.content || '';

      var tagOk =
        activeTag === 'all' ||
        tags.includes(activeTag);

      var searchOk =
        !query ||
        title.includes(query) ||
        content.includes(query);

      var show = tagOk && searchOk;

      card.hidden = !show;

      card.classList.remove('blog-card--featured');

      if (show) {
        visibleCards.push(card);
      }

    });


    if (visibleCards.length > 0) {

      visibleCards[0].classList.add('blog-card--featured');

    }


    var visible = visibleCards.length;


    if (empty) {

      if (visible === 0) {

        empty.textContent = template.replace(
          '{{ tab }}',
          activeLabel
        );

        empty.hidden = false;

      } else {

        empty.hidden = true;

      }

    }

  }



  tabs.forEach(function(tab) {

    tab.addEventListener('click', function() {

      activeTag = tab.dataset.tag;

      activeLabel = tab.textContent.trim();


      setActiveTab(activeTag);


      if (activeTag === 'all') {

        history.pushState(
          {},
          '',
          window.location.pathname
        );

      } else {

        var url = new URL(window.location.href);

        url.searchParams.set(
          'category',
          activeTag
        );

        history.pushState(
          {},
          '',
          url
        );

      }


      applyFilter();

    });

  });



  root.querySelectorAll('[data-card-tag]').forEach(function(tag) {

    tag.addEventListener('click', function() {


      activeTag = tag.dataset.blogTag;


      var matchingTab = root.querySelector(
        '[data-blog-tabs] [data-tag="' + activeTag + '"]'
      );


      if (matchingTab) {

        matchingTab.click();

      }


    });

  });



  if (search) {

    search.addEventListener(
      'input',
      applyFilter
    );

  }



  if (
    activeTag !== 'all' &&
    root.querySelector('[data-blog-tabs] [data-tag="' + activeTag + '"]')
  ) {

    setActiveTab(activeTag);

  } else {

    activeTag = 'all';

    setActiveTab('all');

  }



  applyFilter();


});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pricing-volume"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pricing-volume')) {
    class PricingVolume extends HTMLElement {
      constructor() {
        super();

        this.onInput = this.onInput.bind(this);
        this.onChange = this.onChange.bind(this);
        this.onKeydown = this.onKeydown.bind(this);
        this.onStep = this.onStep.bind(this);
        this.onCta = this.onCta.bind(this);
      }

      connectedCallback() {
        this.max = Math.min(20000, Math.max(1, parseInt(this.dataset.max, 10) || 20000));
        this.step = Math.max(1, parseInt(this.dataset.step, 10) || 50);
        this.suffix = this.dataset.maxSuffix || '';

        this.input = this.querySelector('.pv-input');
        this.live = this.querySelector('[aria-live]');
        this.cards = Array.from(this.querySelectorAll('.pv-card'));
        this.cta = this.querySelector('[data-scroll-target]');

        if (!this.input) return;

        this.value = this.clamp(parseInt(this.dataset.start, 10) || 0);

        this.render();

        this.input.addEventListener('input', this.onInput);
        this.input.addEventListener('change', this.onChange);
        this.input.addEventListener('blur', this.onChange);
        this.input.addEventListener('keydown', this.onKeydown);

        this.querySelectorAll('.pv-step').forEach((button) => {
          button.addEventListener('click', this.onStep);
        });

        if (this.cta) {
          this.cta.addEventListener('click', this.onCta);
        }
      }

      disconnectedCallback() {
        if (!this.input) return;

        this.input.removeEventListener('input', this.onInput);
        this.input.removeEventListener('change', this.onChange);
        this.input.removeEventListener('blur', this.onChange);
        this.input.removeEventListener('keydown', this.onKeydown);

        this.querySelectorAll('.pv-step').forEach((button) => {
          button.removeEventListener('click', this.onStep);
        });

        if (this.cta) {
          this.cta.removeEventListener('click', this.onCta);
        }
      }

      clamp(value) {
        if (isNaN(value)) value = 0;
        return Math.min(this.max, Math.max(0, value));
      }

      parse(value) {
        const digits = String(value).replace(/[^\d]/g, '');
        return digits === '' ? 0 : parseInt(digits, 10);
      }

      format(value) {
        const text = value.toLocaleString('en-US');
        return value >= this.max ? text + this.suffix : text;
      }

      onInput() {
        this.value = this.clamp(this.parse(this.input.value));
        this.updateCards();
      }

      onChange() {
        this.value = this.clamp(this.parse(this.input.value));
        this.render();
      }

      onKeydown(event) {
        if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.adjust(1);
        } else if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.adjust(-1);
        } else if (event.key === 'Enter') {
          event.preventDefault();
          this.onChange();
        }
      }

      onStep(event) {
        const direction = parseInt(event.currentTarget.dataset.stepDir, 10) || 1;
        this.adjust(direction);
      }

      adjust(direction) {
        this.value = this.clamp(this.value + direction * this.step);
        this.render();
      }

      activeIndex() {
        if (!this.cards.length) return -1;

        for (let index = 0; index < this.cards.length; index++) {
          const limit = parseInt(this.cards[index].dataset.limit, 10) || 0;
          if (limit > 0 && this.value <= limit) {
            return index;
          }
        }

        return this.cards.length - 1;
      }

      updateCards() {
        const activeIndex = this.activeIndex();
        let activeTitle = '';

        this.cards.forEach((card, index) => {
          const isActive = index === activeIndex;

          if (card.classList.contains('is-active') !== isActive) {
            card.classList.toggle('is-active', isActive);
          }

          const current = isActive ? 'true' : 'false';
          if (card.getAttribute('aria-current') !== current) {
            card.setAttribute('aria-current', current);
          }

          if (isActive) {
            const title = card.querySelector('.pv-card-title');
            activeTitle = title ? title.textContent.trim() : '';
          }
        });

        if (this.live && activeTitle) {
          this.live.textContent = activeTitle + ' ' + this.format(this.value);
        }
      }

      render() {
        const formatted = this.format(this.value);
        if (this.input.value !== formatted) {
          this.input.value = formatted;
        }
        this.updateCards();
      }

      onCta(event) {
        if (!this.cta) return;

        const sectionId = this.cta.dataset.scrollTarget || '';
        if (!sectionId) return;

        const target =
          document.getElementById(sectionId) ||
          document.getElementById('shopify-section-' + sectionId);

        if (!target) return;

        event.preventDefault();

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }

    customElements.define('pricing-volume', PricingVolume);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.splReady) return;
      root.dataset.splReady = 'true';

      var single = root.dataset.splSingle === 'true';
      var items = Array.prototype.slice.call(root.querySelectorAll('[data-spl-item]'));

      function setOpen(item, open) {
        var btn = item.querySelector('[data-spl-toggle]');
        var panel = item.querySelector('.spl-faq__panel');
        item.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }

      items.forEach(function (item) {
        var btn = item.querySelector('[data-spl-toggle]');
        btn.addEventListener('click', function () {
          var isOpen = item.classList.contains('is-open');
          if (single) {
            items.forEach(function (other) {
              if (other !== item) setOpen(other, false);
            });
          }
          setOpen(item, !isOpen);
        });
      });

      root.splOpenItem = function (blockEl) {
        var item = blockEl.closest('[data-spl-item]');
        if (!item) return;
        if (single) {
          items.forEach(function (other) {
            if (other !== item) setOpen(other, false);
          });
        }
        setOpen(item, true);
      };
    }

    function boot() {
      document.querySelectorAll('[data-spl-faq]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-spl-faq]');
      if (root && root.splOpenItem) root.splOpenItem(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-go-live-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    'use strict';

    function initGoLiveHero(root) {
      if (!root || root.dataset.glhReady === 'true') return;
      var path = root.querySelector('[data-glh-path]');
      if (!path) return;
      root.dataset.glhReady = 'true';

      var svg = path.querySelector('[data-glh-svg]');
      var track = path.querySelector('[data-glh-track]');
      var fill = path.querySelector('[data-glh-fill]');
      var nodesWrap = path.querySelector('[data-glh-nodes]');
      var nodes = Array.prototype.slice.call(path.querySelectorAll('[data-glh-node]'));
      var label = path.querySelector('[data-glh-label]');
      var labelText = path.querySelector('[data-glh-label-text]');
      var count = nodes.length;
      if (count < 2) return;
      nodes[count - 1].classList.add('spl-glh__node--last');

      var opts = {
        start: (parseFloat(root.dataset.scrollStart) || 85) / 100,
        distance: parseFloat(root.dataset.scrollDistance) || 400,
        reverse: root.dataset.reverse !== 'false',
        amplitude: parseFloat(root.dataset.amplitude) || 70,
        mobileVertical: root.dataset.orientation !== 'horizontal',
        showLabel: root.dataset.showLabel === 'true',
        prefix: root.dataset.labelPrefix || 'You are here',
        complete: root.dataset.labelComplete || ''
      };

      var media = window.matchMedia('(max-width: 749px)');
      var layout = 'horizontal';
      var length = 0;
      var maxProgress = 0;
      var points = [];
      var raf = null;

      function nodeSize() {
        return nodes[0].querySelector('.spl-glh__dot').offsetWidth || 44;
      }

      /* ---- geometry ---- */
      function buildHorizontal() {
        var width = path.clientWidth;
        var pathHeight = parseFloat(getComputedStyle(root).getPropertyValue('--glh-path-height')) || 200;
        var amp = Math.min(opts.amplitude, pathHeight * 0.45);
        var size = nodeSize();
        var pad = Math.max(size, 80);
        var cy = Math.round(pathHeight / 2);
        nodesWrap.style.height = pathHeight + 'px';
        points = [];
        for (var i = 0; i < count; i++) {
          var x = pad + (width - pad * 2) * (i / (count - 1));
          points.push({ x: Math.round(x), y: cy });
          nodes[i].style.left = points[i].x + 'px';
          nodes[i].style.top = (cy - size / 2) + 'px';
        }
        var d = 'M' + points[0].x + ' ' + points[0].y;
        for (var j = 1; j < count; j++) {
          var a = points[j - 1], b = points[j];
          var dir = (j % 2 === 1) ? -1 : 1;
          d += ' C ' + (a.x + (b.x - a.x) * 0.35) + ' ' + (a.y + amp * dir) + ', ' + (b.x - (b.x - a.x) * 0.35) + ' ' + (b.y + amp * dir) + ', ' + b.x + ' ' + b.y;
        }
        svg.setAttribute('viewBox', '0 0 ' + width + ' ' + pathHeight);
        svg.setAttribute('width', width);
        svg.setAttribute('height', pathHeight);
        svg.style.height = pathHeight + 'px';
        return d;
      }

      function buildVertical() {
        var size = nodeSize();
        var x = Math.round(size / 2);
        points = [];
        nodesWrap.style.height = '';
        nodes.forEach(function (n) { n.style.left = ''; n.style.top = ''; });
        for (var i = 0; i < count; i++) {
          points.push({ x: x, y: nodes[i].offsetTop + nodes[i].offsetHeight / 2 });
        }
        var d = 'M' + x + ' ' + points[0].y + ' L' + x + ' ' + points[count - 1].y;
        var h = nodesWrap.offsetHeight;
        svg.setAttribute('viewBox', '0 0 ' + path.clientWidth + ' ' + h);
        svg.setAttribute('width', path.clientWidth);
        svg.setAttribute('height', h);
        svg.style.height = h + 'px';
        return d;
      }

      function build() {
        layout = (media.matches && opts.mobileVertical) ? 'vertical' : 'horizontal';
        path.setAttribute('data-layout', layout);
        var d = layout === 'vertical' ? buildVertical() : buildHorizontal();
        track.setAttribute('d', d);
        fill.setAttribute('d', d);
        length = fill.getTotalLength();
        fill.style.strokeDasharray = length + ' ' + length;
        update(true);
      }

      /* ---- progress ---- */
      function computeProgress() {
        var rect = path.getBoundingClientRect();
        var vh = window.innerHeight || document.documentElement.clientHeight;
        var startLine = vh * opts.start;
        var p = (startLine - rect.top) / opts.distance;
        p = Math.max(0, Math.min(1, p));
        if (!opts.reverse) { maxProgress = Math.max(maxProgress, p); p = maxProgress; }
        return p;
      }

      function positionLabel(index, p) {
        if (!label || layout === 'vertical') return;
        if (index < 0) { label.classList.remove('is-visible'); return; }
        var size = nodeSize();
        var x = points[index].x;
        var y = points[index].y;
        var isLast = index === count - 1;
        var text = (p >= 1 && opts.complete) ? opts.complete : (opts.prefix + ' \u00b7 ' + (index + 1) + '/' + count);
        labelText.textContent = text;
        var labelWidth = label.offsetWidth;
        var pathWidth = path.clientWidth;
        var left = x + size / 2 + 10;
        if (isLast || left + labelWidth > pathWidth) {
          left = x - size / 2 - 10 - labelWidth;
          label.style.flexDirection = 'row-reverse';
        } else {
          label.style.flexDirection = 'row';
        }
        label.style.left = Math.max(0, left) + 'px';
        label.style.top = (y - size * 0.9) + 'px';
        label.classList.add('is-visible');
      }

      function update(force) {
        var p = computeProgress();
        if (!force && p === update.last) return;
        update.last = p;
        fill.style.strokeDashoffset = length * (1 - p);

        var current = -1;
        for (var i = 0; i < count; i++) {
          var from = i / (count - 1);
          var to = (i + 1) / (count - 1);
          var state;
          if (p >= 1 || p >= to) state = 'done';
          else if (p >= from && (i > 0 || p > 0.02)) state = 'current';
          else state = 'next';
          if (state === 'current') current = i;
          if (nodes[i].dataset.state !== state) nodes[i].dataset.state = state;
        }
        if (p >= 1) current = count - 1;
        if (opts.showLabel) positionLabel(current, p);
      }
      update.last = -1;

      function onScroll() {
        if (raf) return;
        raf = window.requestAnimationFrame(function () { raf = null; update(false); });
      }

      /* Capture-phase listener catches scroll on window AND any wrapper scroller. */
      document.addEventListener('scroll', onScroll, { capture: true, passive: true });
      window.addEventListener('resize', build);
      if (media.addEventListener) media.addEventListener('change', build);
      if ('ResizeObserver' in window) new ResizeObserver(build).observe(path);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(build);
      build();
    }

    function initAll(scope) {
      (scope || document).querySelectorAll('[data-spl-glh]').forEach(initGoLiveHero);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
    else initAll();
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-privacy-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.spl-privacy').forEach(function (section) {
    var toc = section.querySelector('[data-spl-toc]');
    var list = toc && toc.querySelector('[data-spl-toc-list]');
    if (!list) return;
    var headings = section.querySelectorAll('[data-spl-heading], .spl-privacy__rte h2:not([data-spl-heading])');
    list.innerHTML = '';
    var used = {};
    headings.forEach(function (h) {
      var text = h.textContent.trim().replace(/^\d+[\.\)]\s*/, '');
      var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      var id = base;
      var n = 2;
      while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
      used[id] = true;
      if (!h.id) h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-setup-steps"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.splReady) return;
      root.dataset.splReady = 'true';

      var steps = Array.prototype.slice.call(root.querySelectorAll('[data-spl-step]'));

      function setOpen(step, open) {
        var btn = step.querySelector('[data-spl-toggle]');
        var panel = step.querySelector('.spl-setup__step-panel');
        step.classList.toggle('is-open', open);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', '');
        }
      }

      steps.forEach(function (step) {
        var btn = step.querySelector('[data-spl-toggle]');
        btn.addEventListener('click', function () {
          var isOpen = step.classList.contains('is-open');
          steps.forEach(function (other) {
            if (other !== step) setOpen(other, false);
          });
          setOpen(step, !isOpen);
        });
      });

      var options = Array.prototype.slice.call(root.querySelectorAll('[data-spl-option]'));
      options.forEach(function (input) {
        input.addEventListener('change', function () {
          options.forEach(function (o) {
            o.closest('.spl-setup__option').classList.toggle('is-selected', o.checked);
          });
        });
      });

      root.splOpenStep = function (blockEl) {
        var step = blockEl.closest('[data-spl-step]');
        if (!step) return;
        steps.forEach(function (other) {
          if (other !== step) setOpen(other, false);
        });
        setOpen(step, true);
      };
    }

    function boot() {
      document.querySelectorAll('[data-spl-setup]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-spl-setup]');
      if (root && root.splOpenStep) root.splOpenStep(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-sync-table"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.splReady) return;
      root.dataset.splReady = 'true';

      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-spl-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-spl-panel]'));
      if (!tabs.length) return;

      function activate(id, focus) {
        tabs.forEach(function (tab) {
          var active = tab.dataset.splTab === id;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', active ? 'true' : 'false');
          tab.setAttribute('tabindex', active ? '0' : '-1');
          if (active && focus) tab.focus();
        });
        panels.forEach(function (panel) {
          var active = panel.dataset.splPanel === id;
          panel.classList.toggle('is-active', active);
          if (active) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab.dataset.splTab, false);
        });
        tab.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') next = tabs[0];
          if (event.key === 'End') next = tabs[tabs.length - 1];
          if (next) {
            event.preventDefault();
            activate(next.dataset.splTab, true);
          }
        });
      });

      root.splActivate = activate;
    }

    function boot() {
      document.querySelectorAll('[data-spl-sync]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', boot);
    document.addEventListener('shopify:block:select', function (event) {
      var root = event.target.closest('[data-spl-sync]');
      if (!root || !root.splActivate) return;
      var tab = event.target.closest('[data-spl-tab]');
      var panel = event.target.closest('[data-spl-panel]');
      if (tab) root.splActivate(tab.dataset.splTab, false);
      else if (panel) root.splActivate(panel.dataset.splPanel, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spl-terms-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.spl-terms').forEach(function (section) {
    var toc = section.querySelector('[data-spl-toc]');
    var list = toc && toc.querySelector('[data-spl-toc-list]');
    if (!list) return;
    var headings = section.querySelectorAll('[data-spl-heading]');
    list.innerHTML = '';
    var used = {};
    headings.forEach(function (h) {
      var text = h.textContent.trim().replace(/^\d+[\.\)]\s*/, '');
      var base = text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      var id = base;
      var n = 2;
      while (used[id] || document.getElementById(id)) { id = base + '-' + n++; }
      used[id] = true;
      if (!h.id) h.id = id;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = text;
      li.appendChild(a);
      list.appendChild(li);
    });
  });

  } catch(e) { console.error(e); }
})();
})();
